import { createI18n } from 'vue-i18n';
import fr from './locales/fr.json';
import en from './locales/en.json';
import type { Lang } from '@/types';

// EN/DE/IT/ES/PT seront completes plus tard. FR = base.
export const i18n = createI18n({
  legacy: false,
  locale: 'fr' as Lang,
  fallbackLocale: 'fr',
  messages: { fr, en },
});

export function setLang(l: Lang) {
  (i18n.global.locale as { value: string }).value = l;
  document.documentElement.lang = l;
}
